export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  // Emitted by MessageApi.create while a message WITH attachments is uploading.
  // Payload: { echoId, loaded, total, percent }. Lets the composer/preview show
  // a real upload-progress ring without threading callbacks through Vuex.
  MESSAGE_UPLOAD_PROGRESS: 'MESSAGE_UPLOAD_PROGRESS',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  OPEN_WHATSAPP_TEMPLATE_MODAL: 'OPEN_WHATSAPP_TEMPLATE_MODAL',
  // Abre o modal "Avaliar atendimento" (Eval humano) ancorado numa mensagem:
  // payload { messageId, trecho }. Emitido pelo menu de contexto da mensagem;
  // escutado pelo MoreActions (que monta o modal com o episódio pré-selecionado).
  OPEN_EVAL_MODAL: 'openEvalModal',
};
